import { z, ZodIssueCode } from "zod";

import { AddressObjectInputSchema, HotelI18nInputSchema } from "@/lib/zod/__generated__/validation-schema";

import { postalCodeZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

export const hotelInfoI18nInputZodSchema = HotelI18nInputSchema.extend({
	name: z.string().min(1).max(50),
	catchCopy: z.string().min(1).max(1_000),

	address: AddressObjectInputSchema.extend({
		postalCode: postalCodeZodSchema.nullish(),
		pref: z.string().max(100).nullish(),
		city: z.string().max(300).nullish(),
		town: z.string().max(300).nullish(),
	}).superRefine((data, ctx) => {
		const { postalCode, pref, city, town } = data ?? {};

		// 住所は必須のため、郵便番号、都道府県、市区町村、市区町村以降は必ず入力が必要
		if (!postalCode) {
			ctx.addIssue({
				code: ZodIssueCode.custom,
				message: "郵便番号を入力してください",
				path: ["postalCode"],
			});
		}
		if (!pref) {
			ctx.addIssue({
				code: ZodIssueCode.custom,
				message: "都道府県を入力してください",
				path: ["pref"],
			});
		}

		if (!city) {
			ctx.addIssue({
				code: ZodIssueCode.custom,
				message: "市区町村を入力してください",
				path: ["city"],
			});
		}

		if (!town) {
			ctx.addIssue({
				code: ZodIssueCode.custom,
				message: "市区町村以降を入力してください",
				path: ["town"],
			});
		}
	}),
});

export type HotelInfoI18nZodSchemaType = z.infer<typeof hotelInfoI18nInputZodSchema>;
